var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;opacity:0;}.cls-2{fill:#7effaa;}.cls-3{opacity:0.5;}.cls-4{fill:#00d89a;}.cls-5{fill:#fff;}.cls-6{fill:#ff75b0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_45",
    "data-name": "Layer 45"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -0.9,
    y: 0.29,
    width: 600,
    height: 600
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "weight"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M599.89,205.89Q568.22,391.16,536.57,576.4c-2.41,14.09-14.19,24.38-28,24.38H93.05c-13.77,0-25.54-10.29-27.95-24.38l-12.48-73-10-58.69L1.78,205.9c-2.51-14.67,5.85-29,19.5-33.39a897.72,897.72,0,0,1,109.53-28l.12,0c19-3.61,39.17-6.83,60.43-9.39l.38,0a904.53,904.53,0,0,1,97.08-6.48h.12c2.45,0,4.91-.05,7.36-.07h8.24c1.15,0,2.31,0,3.48,0a907.25,907.25,0,0,1,94.46,5.65l.4,0c21.22,2.4,41.42,5.44,60.5,8.9l.13,0a897.56,897.56,0,0,1,116.9,29.41C594.06,177,602.4,191.25,599.89,205.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M465.4,169.34c0,93.08-75.28,168.55-168.14,168.55h-1c-92.42-.5-167.19-75.78-167.19-168.54a170.35,170.35,0,0,1,1.7-24.06l.12-.82C142.89,63.47,212.3,1.26,296.3.8h.24c.25,0,.47,0,.72,0,83.95,0,153.52,61.69,166.12,142.31,0,.29.09.58.13.87A169.79,169.79,0,0,1,465.4,169.34Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bg-2",
    "data-name": "bg",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M600.89,205.89Q569.22,391.16,537.57,576.4c-2.41,14.09-14.19,24.38-28,24.38H94.05c-13.76,0-25.54-10.29-27.95-24.38l-12.48-73-10-58.69L2.78,205.9c-2.51-14.67,5.85-29,19.5-33.39a897.72,897.72,0,0,1,109.53-28l.12,0c19-3.61,39.17-6.83,60.43-9.39l.39,0a904.16,904.16,0,0,1,97.07-6.48h.12c2.45,0,4.91-.05,7.36-.07h8.24c1.16,0,2.31,0,3.48,0a907.08,907.08,0,0,1,94.46,5.65l.41,0c21.21,2.4,41.41,5.44,60.49,8.9l.13,0a897.15,897.15,0,0,1,116.9,29.41C595.06,177,603.4,191.25,600.89,205.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M466.4,169.34c0,93.08-75.28,168.55-168.14,168.55h-1c-92.42-.5-167.19-75.78-167.19-168.54a170.35,170.35,0,0,1,1.7-24.06l.12-.82C143.89,63.47,213.3,1.26,297.3.8h.25c.24,0,.46,0,.71,0,83.95,0,153.52,61.69,166.12,142.31,0,.29.09.58.13.87A169.79,169.79,0,0,1,466.4,169.34Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M499,259.45q-21,122.76-42,245.49a19,19,0,0,1-18.51,16.15H163.16a19,19,0,0,1-18.52-16.15l-8.27-48.39-6.64-38.89-27-158.2c-1.66-9.72,3.88-19.2,12.93-22.13a595,595,0,0,1,72.57-18.57h.08c12.58-2.39,26-4.53,40-6.22l.25,0a600.32,600.32,0,0,1,64.32-4.29H293c1.62,0,3.24,0,4.87-.05h7.77a602,602,0,0,1,62.58,3.75l.27,0c14.05,1.59,27.44,3.61,40.08,5.9h.09a595,595,0,0,1,77.45,19.49C495.12,240.27,500.64,249.75,499,259.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M499,259.45q-21,122.76-42,245.49a19,19,0,0,1-18.51,16.15H163.16a19,19,0,0,1-18.52-16.15l-8.27-48.39-6.64-38.89-27-158.2c-1.66-9.72,3.88-19.2,12.93-22.13a595,595,0,0,1,72.57-18.57h.08c12.58-2.39,26-4.53,40-6.22l.25,0a600.32,600.32,0,0,1,64.32-4.29H293c1.62,0,3.24,0,4.87-.05h7.77a602,602,0,0,1,62.58,3.75l.27,0c14.05,1.59,27.44,3.61,40.08,5.9h.09a595,595,0,0,1,77.45,19.49C495.12,240.27,500.64,249.75,499,259.45Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "meter"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 297.25,
    cy: 169.66,
    r: 110.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M306,148.1a22.64,22.64,0,0,0-9.48-2.06h-.24a22.59,22.59,0,0,0-8.94,1.91,22.9,22.9,0,0,0,8.94,43.87h.24A22.9,22.9,0,0,0,306,148.1ZM296.54,179h-.24a10,10,0,0,1,0-20h.24a10,10,0,1,1,0,20Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M294.15,66.26,287,151.88a2.54,2.54,0,0,0,2.53,2.75H303.8a2.54,2.54,0,0,0,2.53-2.75l-7.12-85.62A2.54,2.54,0,0,0,294.15,66.26Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeight);
export default __webpack_public_path__ + "static/media/weight.6c61f18d926915a621879b0a060dca38.svg";
export { ForwardRef as ReactComponent };